import {
  Autocomplete,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import LeftArrow from "@mui/icons-material/KeyboardArrowLeft";
import RightArrow from "@mui/icons-material/KeyboardArrowRight";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

const PermissionsRegisters = ({
  permissionsFields,
  handleProductChange,
  control,
  getValues,
  setValue,
  productsList,
  errors,
  loadingProductsAndRoles,
  isBusinessGroup,
  rolesMap,
  companiesMap,
}) => {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(0);
  const [isDesktop, setDesktop] = useState(window.innerWidth > 768);

  /**
   * Handle para actualizar el tamaño de la pantalla
   */
  const updateMedia = () => {
    setDesktop(window.innerWidth > 768);
  };

  // Efecto para actualizar isDesktop cuando la ventana cambia de tamaño
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  const getRolesList = (index) => {
    const productListValue = getValues(`permissions.${index}.productList`);
    const idMenuOption = productListValue
      ? JSON.parse(productListValue).idMenuOption
      : "";
    const result = rolesMap.get(idMenuOption);
    const rolesList = result || [];
    rolesList.sort((a, b) => a.label.localeCompare(b.label));
    return rolesList;
  };

  return (
    <>
      {isDesktop ? (
        <Grid container direction="row" spacing={2}>
          {permissionsFields.map((permission, index) => {
            let productListValue = getValues(
              `permissions.${index}.productList`
            );
            return (
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                spacing={2}
                key={permission.key}
              >
                <Grid item xs={11.5} lg={6}>
                  <FormControl className="full-width">
                    <InputLabel className="modalCreateOptions__form__inputLabel">
                      {t("App.createUser.role")}
                    </InputLabel>

                    <Controller
                      defaultValue=""
                      name={`permissions.${index}.roleList`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          onChange={onChange}
                          value={value}
                          className={`${
                            errors?.permissions?.[index]?.roleList
                              ? "modalEditRoles__form-input--error"
                              : "modalCreateRoles__form-input"
                          } full-width`}
                          disabled={
                            permission.editDisabled
                              ? true // Si editDisabled es true, el campo está deshabilitado
                              : getValues(`permissions.${index}.productList`)
                              ? false
                              : true
                          }
                        >
                          <MenuItem disabled value="">
                            {t("App.createUser.selectOption")}
                          </MenuItem>
                          {productListValue &&
                            getRolesList(index).map((role) => (
                              <MenuItem
                                key={role.value}
                                name={role.label}
                                value={role.value}
                              >
                                {role.label}
                              </MenuItem>
                            ))}
                        </Select>
                      )}
                    />

                    <FormHelperText
                      sx={{
                        margin: "-8px 0 1px 0px",
                        color: "#e52900",
                        fontSize: 10,
                      }}
                    >
                      {errors?.permissions?.[index]?.roleList?.message || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={11.5} lg={6}>
                  <FormControl className="full-width">
                    <InputLabel className="modalCreateOptions__form__inputLabel">
                      {t("App.createUser.status")}
                    </InputLabel>

                    <Controller
                      defaultValue=""
                      name={`permissions.${index}.status`}
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          onChange={onChange}
                          value={value}
                          className={`${
                            errors?.permissions?.[index]?.status
                              ? "modalEditRoles__form-input--error"
                              : "modalCreateRoles__form-input"
                          } full-width`}
                          disabled={
                            permission.editDisabled
                              ? true // Si editDisabled es true, el campo está deshabilitado
                              : getValues(`permissions.${index}.productList`)
                              ? false
                              : true
                          }
                        >
                          <MenuItem disabled value="">
                            {t("App.createUser.selectOption")}
                          </MenuItem>
                          <MenuItem value={1}>
                            {t("App.createRole.active")}
                          </MenuItem>
                          <MenuItem value={0}>
                            {t("App.createRole.inactive")}
                          </MenuItem>
                        </Select>
                      )}
                    />

                    <FormHelperText
                      sx={{
                        margin: "-8px 0 1px 0px",
                        color: "#e52900",
                        fontSize: 10,
                      }}
                    >
                      {errors?.permissions?.[index]?.status?.message || ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Grid container direction="column" spacing={2}>
          {permissionsFields.map((permission, index) => {
            let productListValue = getValues(
              `permissions.${index}.productList`
            );
            return (
              index === currentPage && (
                <Grid
                  item
                  container
                  alignItems="center"
                  justifyContent="center"
                  marginTop="1rem"
                  spacing={2}
                  key={permission.key}
                >
                  <Grid item xs={11.5} lg={6}>
                    <FormControl className="full-width">
                      <InputLabel className="modalCreateOptions__form__inputLabel">
                        {t("App.createUser.role")}
                      </InputLabel>

                      <Controller
                        defaultValue=""
                        name={`permissions.${index}.roleList`}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            onChange={onChange}
                            value={value}
                            className={`${
                              errors?.permissions?.[index]?.roleList
                                ? "modalEditRoles__form-input--error"
                                : "modalCreateRoles__form-input"
                            } full-width`}
                            disabled={
                              permission.editDisabled
                                ? true // Si editDisabled es true, el campo está deshabilitado
                                : getValues(`permissions.${index}.productList`)
                                ? false
                                : true
                            }
                          >
                            <MenuItem disabled value="">
                              {t("App.createUser.selectOption")}
                            </MenuItem>
                            {productListValue &&
                              getRolesList(index).map((role) => (
                                <MenuItem
                                  key={role.value}
                                  name={role.label}
                                  value={role.value}
                                >
                                  {role.label}
                                </MenuItem>
                              ))}
                          </Select>
                        )}
                      />

                      <FormHelperText
                        sx={{
                          margin: "-8px 0 1px 0px",
                          color: "#e52900",
                          fontSize: 10,
                        }}
                      >
                        {errors?.permissions?.[index]?.roleList?.message || ""}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={11.5} lg={6}>
                    <FormControl className="full-width">
                      <InputLabel className="modalCreateOptions__form__inputLabel">
                        {t("App.createUser.status")}
                      </InputLabel>

                      <Controller
                        defaultValue=""
                        name={`permissions.${index}.status`}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            onChange={onChange}
                            value={value}
                            className={`${
                              errors?.permissions?.[index]?.status
                                ? "modalEditRoles__form-input--error"
                                : "modalCreateRoles__form-input"
                            } full-width`}
                            disabled={
                              permission.editDisabled
                                ? true // Si editDisabled es true, el campo está deshabilitado
                                : getValues(`permissions.${index}.productList`)
                                ? false
                                : true
                            }
                          >
                            <MenuItem disabled value="">
                              {t("App.createUser.selectOption")}
                            </MenuItem>
                            <MenuItem value={1}>
                              {t("App.createRole.active")}
                            </MenuItem>
                            <MenuItem value={0}>
                              {t("App.createRole.inactive")}
                            </MenuItem>
                          </Select>
                        )}
                      />

                      <FormHelperText
                        sx={{
                          margin: "-8px 0 1px 0px",
                          color: "#e52900",
                          fontSize: 10,
                        }}
                      >
                        {errors?.permissions?.[index]?.status?.message || ""}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              )
            );
          })}
        </Grid>
      )}
    </>
  );
};

export default PermissionsRegisters;
